<template lang="pug">
    div        
        filters
            slot(slot="statistics")
                base-statistics
                    slot(slot="total")
                        span {{ users.query_total ? users.query_total : 0 }}
            slot(slot="filters")  
                template(v-if="user_group === 1")
                    select-option.w-150(
                        name="group" 
                        :options="USER_GROUPS" 
                        :predefined="USER_GROUPS[0].name"
                        @value="onGroup"
                    )                
                input.border.caret-inherit.pl-2.pr-2.h-10(type="text" v-model="search" placeholder="поиск")
            slot(slot="buttons")
                add-user(@created="onUserCreated")
        users-list(ref="users" :filters="filters" :search="search")
</template>

<script>
//Components
import Filters from '@/components/common/filters';
import RegularButton from '@/components/common/buttons/regular-button';
import UsersList from '@/components/views/users/';
import AddUser from '@/components/views/users/add-user';
import SelectOption from '@/components/common/forms/select-option';
import BaseStatstics from '@/components/common/filters/base-statistics';
//Config
import { BUTTONS_VALUES } from '@/configs/names.js';
import { USER_GROUPS } from '@/configs/user-groups';
//Store
import { UsersNameSpace, UsersGetterTypes } from '@/store/users/types';
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';

export default {
    name: "CategoriesListPage",
    components: {
        'filters': Filters,
        'regular-button': RegularButton,
        'users-list': UsersList,
        'add-user': AddUser,
        'base-statistics': BaseStatstics,
        'select-option': SelectOption,
    },
    data() {
        return {
            //filters
            filters: {
                role: null,
                group: null,
            },
            search: '',
        }
    },
    computed: {
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        users() {
            return this.$store.getters[`${UsersNameSpace}/${UsersGetterTypes.GetResponse}`]
        },
        USER_GROUPS() {
            const result = [{ 
                    name: 'Все группы',
                    value: '',
                    selected: true, 
                    disabled: true, 
                    hidden: true,
                }
            ]
            const filtered_groups = USER_GROUPS.filter(g => { return g.value !== 1 })
            return [...result, ...filtered_groups]
        },
        user_group() {
            return this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetGroup}`]
        },
    },
    methods: {
        onParticipantFilter(value) {
            this.filters.is_number_user = value ? value : null
        },
        onUserCreated() {
            const list = this.$refs.users
            if (!list) {
                return
            }
            list.currentPage = 1
            list.reload()
        },
        onGroup(val) {
            if (val === 'Все группы') {
                this.filters.group = null
            } else {
                this.filters.group = this.USER_GROUPS.find(g => g.name === val).value
            }
            this.search = ''
        },
    }
}
</script>